import { Paper, Button, SxProps, Theme } from "@mui/material";
// import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
// import { Link } from "react-router-dom";
import BodyText from "../../../components/BodyText";
import SmallText from "../../../components/Smalltext";
import { ErrorViewButtonConfig } from "../../../types/types";
import BrokenLinkImg from "../../../assets/link_broken.svg";
import { Link } from "react-router-dom";

interface Props {
  paperSx: SxProps<Theme>;
  message: string | undefined;
  onContactCustomerSupport: () => void;
  buttonConfig: ErrorViewButtonConfig;
  title: string | undefined;
}

const ErrorView = ({
  message,
  onContactCustomerSupport: contactCustomerSupportHandler,
  paperSx,
  buttonConfig,
  title,
}: Props) => (
  <Paper
    sx={{ ...paperSx, paddingTop: "40px", paddingBottom: "30px" }}
    elevation={3}
  >
    <div style={{ padding: "30px", textAlign: "center" }}>
      <img
        src={BrokenLinkImg}
        alt="Broken Link"
        style={{ width: 50, height: 50, marginBottom: 10 }}
      />

      <BodyText sx={{ fontWeight: 600, fontSize: "18px", mb: 0.5 }}>
        {message?.includes("Oh no,") ? (message?.split("\n")[0] ?? "") : title}
      </BodyText>
      <SmallText
        sx={{ fontWeight: 500, color: "#888072", fontFamily: "Roboto" }}
      >
        {message?.includes("Oh no,")
          ? (message?.split("\n")[1] ?? "")
          : message}
      </SmallText>
    </div>

    {buttonConfig.showButton ? (
      <div style={{ paddingLeft: "1", paddingRight: "1" }}>
        <Button
          variant="outlined"
          color="secondary"
          sx={{
            width: "100%",
            px: 5,
          }}
          href={buttonConfig.href}
          onClick={buttonConfig.onClick}
          fullWidth
        >
          {buttonConfig.text ?? "Try Again"}
        </Button>
      </div>
    ) : undefined}

    {!message?.includes("Oh no,") ? (
      <>
        <Link style={{ paddingTop: "20px" }} to={"tel:877 215 4741"}>
          1 (877) 215-4741
        </Link>
        <SmallText sx={{ mt: 1, px: 1 }} color="secondary" center>
          Mon-Fri | 9am-6pm EST
        </SmallText>
        <Link
          style={{ paddingTop: "20px" }}
          to={"mailto:support@cosmotogether.com"}
        >
          support@cosmotogether.com
        </Link>
      </>
    ) : (
      <>
        <SmallText
          sx={{
            fontWeight: 500,
            fontSize: "14px",
            fontFamily: "Roboto",
            mt: 2,
            mb: 0,
            color: "#888072",
          }}
          center
        >
          Not activating?
        </SmallText>
        <Button
          variant="text"
          sx={{
            fontWeight: 500,
            fontSize: "14px",
            fontFamily: "Roboto",
            color: "#052B5D",
          }}
          onClick={contactCustomerSupportHandler}
        >
          Contact customer support for assistance.
        </Button>
      </>
    )}
  </Paper>
);
export default ErrorView;
